var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconNext = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 12,
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Isolation_Mode",
  clipPath: "url(#clip0_3896_5573)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M10.9864 5.05194C11.1702 5.23579 11.2763 5.48327 11.2834 5.75904C11.2834 6.31059 10.8379 6.75606 10.2863 6.75606L1.79398 6.76314C1.24244 6.76314 0.79696 6.31766 0.79696 5.76612C0.79696 5.21457 1.24244 4.76909 1.79398 4.76909L10.2793 4.75495C10.5621 4.75495 10.8025 4.86809 10.9864 5.05194Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M7.45082 1.5166L10.9864 5.05213C11.3753 5.44104 11.3753 6.07743 10.9864 6.46634L7.45082 10.0019C7.06191 10.3908 6.42552 10.3908 6.03661 10.0019C5.6477 9.61297 5.6477 8.97657 6.03661 8.58766L8.86503 5.75924L6.03661 2.93081C5.6477 2.5419 5.6477 1.90551 6.03661 1.5166C6.42552 1.12769 7.06191 1.12769 7.45082 1.5166Z",
  fill: "white"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_3896_5573"
}, /*#__PURE__*/React.createElement("rect", {
  width: 8,
  height: 8,
  fill: "white",
  transform: "translate(6.03662 11.416) rotate(-135)"
})))));
export default SvgIconNext;